import { render, staticRenderFns } from "./ProfileInvestor.vue?vue&type=template&id=54292d07&"
import script from "./ProfileInvestor.vue?vue&type=script&lang=js&"
export * from "./ProfileInvestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports